import { useCallback } from 'react';

interface TokenDetails {
    tokenId: string;
    address: string;
    type?: string;
}
export function useWatchAssets() {
    return useCallback(async ({ address, tokenId, type }: TokenDetails) => {
        try {
            return await window.ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                    type: type || 'ERC721',
                    options: {
                        address,
                        tokenId,
                    },
                },
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            return false;
        }
    }, []);
}
